// extracted by mini-css-extract-plugin
export default {"switch":"ThemeSwitch_switch__iudgV","core":"ThemeSwitch_core__e92Gp"};